import { useState } from "react";
import { useForm } from "react-hook-form";
import { Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useAddSessionEventMutation, useGetEventTypeQuery } from "../../features/CallApi";
import LoadScreen from "../UI/LoadScreen";


export const AddSessionEvent = ({refetchList}) => {

    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const [modal, setModal] = useState(false);
    const { data: eventTypes, isLoading: isIoadingType, refetch } = useGetEventTypeQuery()
    const [addSessionEvent, { isLoading: posting }] = useAddSessionEventMutation();

    const toggle = () => {
        if (!modal) {
            refetch()
        }
        setModal(!modal);

    }

    const postNewEvent = (data) => {
        data.eventType = parseInt(data.eventType)
        console.log(data)
        addSessionEvent(data).then(() => {
            reset()
            setModal(false)
            refetchList()
        }).catch((e) => {
            refetchList()
            alert("Ошибка добавления списка")
            console.log(e)
        })
    }

    return (
        <div>
            <Button className='mb-2' color="success" size="sm" onClick={toggle}>
                Добавить список
            </Button>
            <Modal isOpen={modal} toggle={toggle}>
                {!isIoadingType || !posting ?
                    <form onSubmit={handleSubmit(postNewEvent)}>
                        <ModalHeader>Создание списка</ModalHeader>
                        <ModalBody>
                            <div className="form-floating mb-3">
                                <input type="name" className={`form-control ${errors.name ? "is-invalid" : ""}`} id="name" placeholder="Название"
                                    {...register("name", { required: { value: true, message: "Укажите название списка" } })} />
                                <label htmlFor="name">Название</label>
                                {errors.name && <div><span className='text-danger'>{errors.name?.message}</span></div>}
                            </div>
                            <div className="form-floating mb-3">
                                <input type="date" className={`form-control ${errors.name ? "is-invalid" : ""}`} id="dateEvent" placeholder="Дата мероприятия"
                                    {...register("dateEvent", { required: { value: true, message: "Укажите дату мероприятия" } })} />
                                <label htmlFor="dateEvent">Дата мероприятия</label>
                                {errors.dateEvent && <div><span className='text-danger'>{errors.dateEvent?.message}</span></div>}
                            </div>
                            <div className="form-floating mb-3">
                                <select defaultValue={""} {...register("eventType", { required: { value: true, message: "Выберите тип списка" } })}
                                    className={`form-select ${errors.typeOfEvent ? "is-invalid" : ""}`} id="typeOfEvent">
                                        <option hidden disabled value="">--- Выберите тип списка ---</option>
                                    {eventTypes && eventTypes.map(eventType =>
                                        <option key={eventType.id} value={eventType.id}>{eventType.name}</option>
                                    )}
                                </select>
                                <label htmlFor="typeOfEvent">Тип списка</label>
                                {errors.typeOfEvent && <div><span className='text-danger'>{errors.typeOfEvent?.message}</span></div>}
                            </div>

                        </ModalBody>
                        <ModalFooter>
                            <ButtonGroup>
                                <Button color="success" size="sm">Создать</Button>
                                <Button size="sm" onClick={() => {
                                    reset()
                                    toggle()
                                }}>Отмена</Button>
                            </ButtonGroup>
                        </ModalFooter>
                    </form> : <LoadScreen />
                }
            </Modal>
        </div >
    )
}